import styled from "styled-components";
import { Box, Flex, Text } from "rebass";
export const Header = styled(Flex)`
  height: 61px;
  background: #121212;
  border: solid 1px #121212;
  border-radius: 5px 5px 0px 0px;
`;

export const Right = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const Left = styled(Box)`
  display: flex;
`;

export const IconWrapper = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: white;
  border-radius: 50%;
  border-width: 5px;
`;

export const LeftText = styled(Text)`
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`;

export const WithIconBox = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const InputWrapper = styled.div`
  position: absolute;
  bottom: 0;
`;
